import { styled } from 'styled-components';

const StyledTableOfContents = styled.div`
ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
`;

const StyledTableOfContentsListItem = styled.li`
  ${(props) =>
  props.depth > 2 &&
    `padding-left: calc(1.3em * ${props.depth - 2});`
  }
  line-height: 1.3em;
  padding-bottom: 0.7em;

  a {
    padding-inline-start: 0;
    font-size: 1em;
    word-spacing: 0em;
    color: ${(props) => props.theme.colors.text.tertiary};
    text-decoration: none;
    border-radius: 5px;

    &:hover {
      background-color: transparent !important;
      color: ${(props) => props.theme.colors.text.emphasized};
    }
  }

  &.active a {
    background-color: transparent !important;
    color: ${(props) => props.theme.colors.text.emphasized};
  }
`;

export { StyledTableOfContents, StyledTableOfContentsListItem };
